var map = {
	"./Html.png": 4139,
	"./Javascript.png": 6725,
	"./Mongodb.png": 9336,
	"./Mysql.png": 2724,
	"./Postgres.png": 5241,
	"./Reactjs.png": 6002,
	"./Reactnative.png": 4214,
	"./Redux.png": 72,
	"./css.png": 8235,
	"./express.png": 926,
	"./github.png": 8917,
	"./java.png": 3948,
	"./node.png": 9084,
	"./oops.png": 8777
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1007;